import { Application } from "@hotwired/stimulus"
import Pagy from "../pagy.mjs"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// Initialize Pagy on page load and after Turbo navigations
window.addEventListener("turbo:load", () => Pagy.init())
window.addEventListener("turbo:frame-load", ({ target }) => Pagy.init(target))

export { application }
